<template>
  <div id="tail">
    <div id="left">
      <p>友情链接</p>
      <a class="slight-word" :href="item.Url" v-for="item in links">{{item.Title}}</a>
    </div>

    <div id="right">
      <p class="mes-font">联系电话：（86-10）62797212 （86-10）62773829 传真：（86-10）62797212 </p>
      <p class="mes-font">主办：福建省应急管理研究中心</p>
      <p class="mes-font">版权所有 福建省应急管理研究中心 Copyright © 2021, All Rights Reserved</p>
      <p class="mes-font">闽ICP备17006511号-2</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "tail",
  async created() {
    this.links = await this.$net.index.getLink();
  },
  data() {
    return {
      links: []
    };
  }
};
</script>
<style lang="scss" scoped>
#tail {
  width: 100%;
  // min-height: 180px;
  height: 180px;
  padding: 20px 0;
  background-color: rgba(0, 135, 211, 1);
  color: white;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 62px rgba(0, 0, 0, 0.35);
}
.slight-word {
  font-size: 16px;
  color: #f5f5f5;
  opacity: 0.5;
  margin-right: 15px;
}
.slight-word-smaller {
  font-size: 10px;
  margin: 0;
}
#left {
  color: #f5f5f5;
  font-family: "Arial Normal", "Arial";
  font-size: 24px;
  width: 300px;
  p {
    margin-bottom: 5px;
  }
}
#right {
  font-family: "Arial Normal", "Arial";
  font-size: 16px;
  color: #f5f5f5;
}
.mes-font {
  margin-top: 10px;
}

#right {
  font-family: "Arial Normal", "Arial";
  font-size: 16px;
  color: #f5f5f5;
}
.mes-font {
  margin-top: 10px;
}
</style>
